import * as React from 'react'
import { SSPagination } from '@dotdev/reactive-searchspring'
import * as Snippets from 'snippets'

export class Pagination extends React.Component<SSPagination.Component.Props> {
  public render(): JSX.Element {
    const { currentPage } = this.props.pagination

    return (
      <div className="w-full mx-auto lg:w-3/4 flex flex-no-wrap py-4 lg:py-2-4 items-center justify-center text-sm text-dark">
        {this.props.pagination.currentPage > 1 && (
          <div
            className="uppercase tracking-widest font-semibold px-1-2 cursor-pointer "
            onClick={() => (this.props.changePage(-1), window.scrollTo({ top: 0, behavior: 'smooth' }))}
          >
            <Snippets.Icon name="arrow_left" height={14} width={14} className="mr-0-6 md:mr-1-2 -mb-0-2" />
            {/* <span className="hidden md:inline-block">Previous</span>
            <span className="md:hidden">Prev</span> */}
          </div>
        )}

        {Array.apply(null, { length: this.props.pagination.totalPages }).map((e, i) => (
          <div
            key={i?.toString()}
            className={`cursor-pointer transition-all hover:underline font-sans font-medium px-0-8 md:px-1-2 text-dark
              ${currentPage == i + 1 ? 'relative underline' : ''}
              ${
          i == 0 || i + 1 == this.props.pagination.totalPages || (currentPage >= i - 1 && currentPage <= i + 3)
            ? 'md:block'
            : 'md:hidden'
          }
              ${
          i == 0 || i + 1 == this.props.pagination.totalPages || currentPage == i || currentPage == i + 1 || currentPage == i + 2
            ? ''
            : 'block'
          }
              ${i == currentPage + 1 && i + 1 < this.props.pagination.totalPages - 1 ? 'md-page-after' : ''}
              ${i == currentPage && i + 2 < this.props.pagination.totalPages - 1 ? 'page-after' : ''}
              ${i == currentPage - 3 && i > 1 ? 'md-page-before' : ''}
              ${i == currentPage - 2 && i > 1 ? 'page-before' : ''}`}
            onClick={(event: React.MouseEvent<HTMLElement>) => {
              this.props.changePage(i + 1, true), window.scrollTo({ top: 0, behavior: 'smooth' })
            }}
          >
            {i + 1}
          </div>
        ))}

        {this.props.pagination.currentPage < this.props.pagination.totalPages && (
          <div
            className="uppercase tracking-widest font-semibold px-1-2 cursor-pointer"
            onClick={() => (this.props.changePage(1), window.scrollTo({ top: 0, behavior: 'smooth' }))}
          >
            {/* Next */}
            <Snippets.Icon name="arrow_right" height={14} width={14} className="ml-0-6 md:ml-1-2 -mb-0-3" />
          </div>
        )}
      </div>
    )
  }
}